import {Stack} from '@mui/material';
import {PropsWithChildren} from 'react';
import {HelpTutorialEnum, helpTutorialMap} from '../../variables/helpTutorial';
import HelpButton from './HelpButton';

export interface HelpButtonWrapperProps {
  helpTutorialEnum: HelpTutorialEnum;
}

export default function HelpButtonWrapper({children, helpTutorialEnum}: PropsWithChildren<HelpButtonWrapperProps>) {
  return (
    <Stack direction="row" spacing={2}>
      {children}
      {}
      <HelpButton {...helpTutorialMap[helpTutorialEnum]} />
    </Stack>
  );
}
